import { Root } from './routes/route';

const App: React.FC = () => {
  return <Root />;
};

export default App;
